export default __webpack_public_path__ + "static/tks-24ddf3ca0ba80fe7266be3c7ab630c7a.png";